<script>
import BOForm from '../../baseComponents/boForm'
import { SET_SUBBOT } from '../../variables'
export default {
	extends: BOForm,
	data() {
		return {
			items: [
				{ label: 'Nom', value: 'name', type: 'text', required: true },
				{ label: 'Reference', value: 'ref', type: 'text', required: false },
				{ label: 'Lien', value: 'link', type: 'text', required: false, disabled: true },
				{ label: 'Clef', value: 'key', type: 'text', required: true, disabled: true },
				{ label: 'Envoyé à', value: 'totalSend', type: 'number', required: false }
			]
		}
	},
	methods: {
		async post() {},
		async put() {
			if (!this.model.ref) {
				this.model.ref = null
			}
			await this.axios.put('subBots/' + this.model._id, this.model)
			//update link
			await this.$store.dispatch(SET_SUBBOT, { id: this.model._id, reload: true })
			this.model.link = this.$store.getters.subBot.link
			this.$forceUpdate();
		}
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/subBots/subBot.form.vue